export enum ContactTypeEnumEntity {
  ARCHITECT = 1,
  CLIENT = 2,
  TRADERS = 3
}

export enum StorageKeyEnum {
  JB_GLASS_USER_INFO = "jb_glass_user_info",
}

export enum ContactTypeNameEnum {
  ARCHITECT = "Architect",
  CLIENT = "Client",
  TRADERS = "Traders",
}